<div class="container-flex">
    <div class="row py-1">
        <div class="col-md-8">
            <app-patients-overview></app-patients-overview>
        </div>
        @if (timeWindowSuggestionsCount$ | async; as suggestionsCount) {
            <div
                class="col-md-4 d-flex justify-content-end"
            >
                <app-button
                    label="SUGGESTIONS_ON_TIME_WINDOWS"
                    [notification]="true"
                    [notificationLabel]="suggestionsCount"
                    (clicked)="openTimeWindowSuggestionsModal()"
                ></app-button>
            </div>
        }
    </div>

    <div class="row h-100">
        <div class="col-md-5 container-flex">
            <app-patients class="container-flex patients-panel" (selectPatient)="selectPatient($event)"></app-patients>
        </div>

        <div class="col-md-7 container-flex">
            <app-patient-info class="container-flex" [patient]="patient"></app-patient-info>
        </div>
    </div>
</div>
